import { render, staticRenderFns } from "./Multi.vue?vue&type=template&id=49b8b5d3&scoped=true&"
import script from "./Multi.vue?vue&type=script&lang=ts&"
export * from "./Multi.vue?vue&type=script&lang=ts&"
import style0 from "./Multi.vue?vue&type=style&index=0&id=49b8b5d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8b5d3",
  null
  
)

export default component.exports